/* eslint-disable */ import { attributeSelectionComponent, memoEval, sceneEntityObjectPropertiesComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { Handing } from '../model/index.js';
export const bottomAdjustableDoorApplianceComponents = [
    attachComponent.withComponent(attributeSelectionComponent, 'handing', true).withAlias('BottomAdjustableDoorAppliance').attach(memoEval((self)=>[
            self.handing,
            self.$handingOptions
        ], (handing, $handingOptions)=>({
            value: handing,
            options: $handingOptions
        })), (state)=>{
        Handing.assert(state.value);
        return {
            handing: state.value
        };
    }),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'default', true).withAlias('BottomAdjustableDoorAppliance').attach(memoEval((self)=>[
            self.$offsetX,
            self.$offsetY
        ], ($offsetX, $offsetY)=>({
            offsetX: $offsetX,
            offsetY: $offsetY
        })))
];

//# sourceMappingURL=bottom-adjustable-door-appliance.js.map